import React from "react";
import Select, { ActionMeta, SingleValue } from "react-select";
import { LabelValuePair } from "models/label-value";
import { CountryCodes } from "models/settings/master-data";

interface CountrySelectorProps {
  selectedCountry: LabelValuePair;
  onChange: (newValue: SingleValue<LabelValuePair>, actionMeta: ActionMeta<LabelValuePair>) => void;
}

const CountrySelector: React.FC<CountrySelectorProps> = ({ selectedCountry, onChange }) => {
  return (
    <Select
      options={CountryCodes}
      value={selectedCountry}
      onChange={onChange}
      placeholder="Select Country"
      isSearchable
    />
  );
};

export default CountrySelector;
